// extracted by mini-css-extract-plugin
export default {"failure":"failure_failure__6q6lO","failWarnIcon":"failure_failWarnIcon__IuLZH","text":"failure_text__J9YRQ","rotate":"failure_rotate__PJeAh"};